import React from 'react';
import get from 'lodash/get';
import Button from '../../../../bootstrap/Button.jsx';
import Portal from '../../../../common/Portal.jsx';
import { FaIcon } from '../../../../common/Icons.jsx';
import { useFormulaFields } from '../../../hooks/useFormulaFields.js';
import { useFormulaDialog } from './useFormulaDialog.js';
import FormulaFieldDialog from './FormulaFieldDialog.jsx';
import styles from './FormulaField.module.scss';

/**
 * "Create formula" / "Edit formula" links shown below a series column picker.
 * Saving a new formula selects it for the given series attribute.
 */
function FormulaFieldActions({ widgetId, attr, selectedObject, setAttribute }) {
  const { formulaFields } = useFormulaFields(widgetId);
  const { open, editedField, openDialog, closeDialog } = useFormulaDialog();

  const selectedField = formulaFields.find(f => f.accessor === get(selectedObject, attr));

  return (
    <div className={styles['formula-actions']}>
      <Button type='link' size='xs' onClick={() => openDialog()}>
        <FaIcon type='plus' /> {I18n.t('create_formula')}
      </Button>
      {selectedField && (
        <Button type='link' size='xs' onClick={() => openDialog(selectedField)}>
          <FaIcon type='pencil' /> {I18n.t('edit_formula')}
        </Button>
      )}
      {open && (
        <Portal
          component={FormulaFieldDialog}
          widgetId={widgetId}
          field={editedField}
          onSaved={field => setAttribute(attr, field.accessor)}
          closeDialog={closeDialog}
        />
      )}
    </div>
  );
}

export default FormulaFieldActions;
